<template>
    <portal>
        <div class=" d-flex align-center" >
            <v-icon color="primary" size="30">mdi-file-lock</v-icon>
            <h1 style="margin-bottom: 0px;" class="headline ml-4 font-weight-bold grey--text--darken-2 text-uppercase">Vault</h1>
        </div>

        <Folders :household-id="this.user.household_id"></Folders>
    </portal>
</template>

<script>

import Portal from "@/components/Portal";
import Folders from "@/components/vault/Folders";
import {mapState} from "vuex";
export default {
    components: {
        Folders,
        Portal
    },

    computed: {
        ...mapState('auth', [
            'user'
        ]),
    },

    data() {
        return {
            files: {
                html: 'mdi-language-html5',
                js: 'mdi-nodejs',
                json: 'mdi-code-json',
                md: 'mdi-language-markdown',
                pdf: 'mdi-file-pdf',
                png: 'mdi-file-image',
                txt: 'mdi-file-document-outline'
            },
            items: [
                {
                    id: 1,
                    name: 'Downloads',
                    children: [
                        {
                            name: 'financial_summary.pdf',
                            file: 'pdf'
                        },
                        {
                            name: 'net_worth_summary.pdf',
                            file: 'pdf'
                        },
                        {
                            name: 'note.txt',
                            file: 'txt'
                        }
                    ]
                },
                {
                    id: 2,
                    name: 'Documents',
                    children: [
                        {
                            name: 'chart.png',
                            file: 'png'
                        },
                    ]
                }
            ]
        }
    }
}
</script>
